var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdwIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1832_3054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0822 0.473633H3.78433C2.99951 0.473633 2.36328 1.10986 2.36328 1.89469V16.1052C2.36328 16.89 2.99951 17.5263 3.78433 17.5263H14.0822C14.8671 17.5263 15.5033 16.89 15.5033 16.1052V1.89469C15.5033 1.10986 14.8671 0.473633 14.0822 0.473633Z",
    stroke: "#747593",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93848 0.473633V17.5263",
    stroke: "#747593",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5035 6.34717H1.83301",
    stroke: "#747593",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5035 11.6528H1.83301",
    stroke: "#747593",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02339 3.99805H1.91812C1.1333 3.99805 0.49707 4.63427 0.49707 5.4191V12.5812C0.49707 13.366 1.1333 14.0023 1.91812 14.0023H9.02339C9.80821 14.0023 10.4444 13.366 10.4444 12.5812V5.4191C10.4444 4.63427 9.80821 3.99805 9.02339 3.99805Z",
    fill: "white",
    stroke: "#747593",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28008 10.819L3.66113 7.18115",
    stroke: "#747593",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28008 7.18115L3.66113 10.819",
    stroke: "#747593",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1832_3054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9537,
    height: 18,
    fill: "white",
    transform: "translate(0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdwIcon);
export default __webpack_public_path__ + "static/media/pdw-icon.dda1ba3649c939e32776ed239e3dd02a.svg";
export { ForwardRef as ReactComponent };